import { DearisHardware } from "./pre-setting-hardware";

export default function () {
  return <DearisHardware />;
}
